<template>
  <div class="wrraper">
    <!-- Start Breadcrumb -->
    <Breadcrumb :items="items" :canAdd="!canAdd" />
    <!-- End Breadcrumb -->
    <!-- <main-filter @getResult="setRows" /> -->
    <!-- Start Statistics Card-->

    <!-- Start Main Loader -->
    <transition name="fadeInUp" mode="out-in" v-if="loaderPage">
      <MainLoader />
    </transition>
    <!-- End Main Loader -->
    <div class="fadeIn" v-else>
      <!-- <div class="row mb-5">
        <div class="wrraper">
          <stats-card
            :title="$t('countriesNum')"
            :number="statisticsItem.number"
          ></stats-card>
        </div>
      </div> -->
      <!-- End Statistics Card-->
      <template>
        <!-- Start Main Section -->
        <main>
          <v-data-table
            class="elevation-1 thumb diff_table"
            :headers="headers"
            :items="branches"
            :search="search"
            :custom-filter="helper_filterSearch"
            :loading="loading"
            :loading-text="$t('table.loadingData')"
            item-key="id"
            :items-per-page="paginations.items_per_page"
            hide-default-footer
          >
            <!-- ================== You Can use any slots you want ================== -->
            <!-- Select no data State -->
            <template v-slot:no-data>
              {{ $t("table.noData") }}
            </template>

            <!-- avatar -->
            <!-- <template v-slot:[`item.image`]="{ item }">
              <img @click="show_model_1" class="image" :src="item.image" />
            </template> -->
            <template v-slot:[`item.index`]="{ index }">
              {{ index + 1 }}
            </template>
            <!-- Select actions-->
            <template v-slot:[`item.actions`]="{ item }">
              <div class="_actions">
                <!-- <v-icon class="show" small @click="showItem(item)">
              fal fa-eye
            </v-icon> -->
                <v-icon
                  class="edit"
                  v-if="!canEdit"
                  small
                  @click="editItem(item)"
                >
                  fal fa-edit
                </v-icon>
                <v-icon
                  class="delete"
                  v-if="!canDelete"
                  small
                  @click="deleteItem(item)"
                >
                  fal fa-trash
                </v-icon>
              </div>
            </template>

            <!-- ======================== Start Top Section ======================== -->
            <template v-slot:top>
              <h3 class="title table-title">الفروع</h3>
              <!-- Delete dialog -->
              <v-dialog v-model="dialogDelete" max-width="500px">
                <v-card>
                  <v-card-title class="text-h5 justify-center">
                    {{ $t("table.deletedialog.areYouSure") }}
                  </v-card-title>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="#1B5E20" @click="deleteItemConfirm">
                      {{ $t("table.deletedialog.ok") }}
                    </v-btn>
                    <v-btn color="#F44336" @click="dialogDelete = false">
                      {{ $t("table.deletedialog.cancel") }}
                    </v-btn>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <!-- Add & Delete -->
              <v-row>
                <v-col cols="12" sm="8"></v-col>
              </v-row>
            </template>
            <!-- ======================== End Top Section ======================== -->
          </v-data-table>
          <div v-if="selectedItem" class="col-lg-3 selected_message">
            <div class="show_message">
              <h3>{{ selectedItem }}</h3>
              <a
                v-if="selectedMessage.contact.email"
                :href="`mailto:${selectedMessage.contact.email}`"
                target="_blank"
              >
                {{ selectedMessage.contact.email }}
                <img src="@/assets/images/icons/chating.svg" />
              </a>
              <a
                v-if="showItem.contact.phone"
                :href="`tel:${selectedMessage.contact.phone}`"
                target="_blank"
              >
                {{ showItem.contact.phone }}
                <img src="@/assets/images/icons/phoneIcon.svg" />
              </a>
              <p>
                {{ selectedMessage.contact.service }}
              </p>
              <div class="details" v-if="selectedMessage.contact.sent_at">
                <span>
                  تم أرسالها
                </span>
                <span>
                  {{ selectedMessage.contact.sent_at }}
                </span>
              </div>
              <div class="details" v-if="selectedMessage.contact.read_at">
                <span>
                  تم قرأتها
                </span>
                <span>
                  {{ selectedMessage.contact.read_at }}
                </span>
              </div>
              <div class="message_content">
                <h6>{{ selectedMessage.contact.subject }}</h6>
                <p>{{ selectedMessage.contact.content }}</p>
              </div>
              <div class="recent_messages">
                <h6>{{ selectedMessage.recent_messages }}</h6>
              </div>
            </div>
          </div>
        </main>
        <!-- End Main Section -->

        <!-- Start Pagination -->
        <template>
          <div
            class="pagination_container tw-text-center mb-5 d-flex justify-content-between"
          >
            <!-- <div class="select-pagination d-flex">
              <span class="first">{{ $t('show') }}</span>
              <v-select
                :items="[5, 20, 50, 100]"
                v-model="paginations.items_per_page"
              ></v-select>
              <span>{{ $t('entries') }}</span>
            </div> -->

            <v-pagination
              v-model.number="paginations.current_page"
              :length="paginations.last_page"
              :total-visible="5"
              @input="fetchData($event)"
            ></v-pagination>
          </div>
        </template>
        <!-- End Pagination -->

        <!-- Start Image_Model -->
        <base-model
          @closeModel="model_1.show_model = false"
          :show="model_1.show_model"
        >
          <div class="image">
            <img
              v-if="model_1.model_img_src"
              :src="model_1.model_img_src"
              alt="..."
            />
          </div>
        </base-model>
        <!-- End Image_Model -->
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      // ========== Main Loader
      loaderPage: false,
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.branches.title"),
          disabled: false,
          href: "/branches",
        },
        {
          text: this.$t("breadcrumb.branches.all"),
          disabled: true,
          href: "",
        },
      ],

      // ========== Statistics
      statisticsItem: {},

      // ========== Top Section
      search: "",

      // ========== dialog Status
      dialogDelete: false,
      itemtoDelete: null,

      // ========== Model
      model_1: {
        show_model: false,
        model_img_src: "",
      },
      selectedItem: false,
      // ========== Body Section
      calories: "",

      // ========== Your Data
      branches: [], // injected in created

      // ========== pagination
      paginations: {
        current_page: 1,
        last_page: 2,
        items_per_page: 20,
      },

      // ========== Loding
      loading: false,
    };
  },

  computed: {
    ...mapGetters({
      lang: "lang_module/lang",
    }),

    headers() {
      if (this.lang == "ar") {
        return [
          {
            text: "#",
            align: "center",
            value: "index",
            sortable: true,
          },
          {
            text: "(عربي) اسم الفرع",
            align: "center",
            value: "title_ar",
            sortable: false,
          },
          {
            text: "(انجليزي) اسم الفرع",
            align: "center",
            value: "title_en",
            sortable: false,
          },
          {
            text: "العنوان التفصيلي",
            align: "center",
            value: "description",
            sortable: false,
          },
          {
            text: "التحكم",
            value: "actions",
            sortable: false,
            align: "center",
          },
        ];
      } else {
        return [
          {
            text: "#",
            align: "center",
            value: "id",
            sortable: true,
          },
          {
            text: "Name (Ar)",
            align: "center",
            value: "ar.title",
            sortable: false,
          },
          {
            text: "Name (En)",
            align: "center",
            value: "en.title",
            sortable: false,
          },
          {
            text: "Phone Code",
            align: "center",
            value: "description",
            sortable: false,
          },
          {
            text: "Actions",
            value: "actions",
            sortable: false,
            align: "center",
          },
        ];
      }
    },
  },

  methods: {
    // ===== Search Method =====
    filterClick(word) {
      if (!this.loading) {
        this.search = word;
        this.helper_filterSearch();
      }
    },

    // img Model
    show_model_1(e) {
      this.model_1.model_img_src = e.target.src;
      this.model_1.show_model = true;
    },

    // ==================== Start CRUD ====================
    addItem() {
      this.$router.push({ path: "/branches/add" });
    },
    showItem(item) {
      this.axios({
        method: "GET",
        url: `branch/${item.id}`,
      })
        .then((res) => {
          this.selecteditem = res.data.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    editItem(item) {
      this.$router.push({ path: "/branches/edit/" + item.id });
    },
    // ===== Delete
    deleteItem(item) {
      this.dialogDelete = true;
      this.itemtoDelete = item;
    },
    deleteItemConfirm() {
      this.axios({
        method: "DELETE",
        url: `branch/${this.itemtoDelete.id}`,
      })
        .then(() => {
          this.branches = this.branches.filter((item) => {
            return item.id != this.itemtoDelete.id;
          });
          this.dialogDelete = false;
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("deleteSuccess"),
            position: "bottomRight",
          });
        })
        .catch((err) => {
          this.dialogDelete = false;
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.message,
            position: "bottomRight",
          });
        });
    },
    // ==================== End CRUD ====================

    // Set Rows
    setRows() {
      this.loading = true;
      this.loaderPage = true;

      this.axios({
        method: "GET",
        url: "branch",
        // params: {
        //   page: this.paginations.current_page,
        //   keyword: e?.searchInput ? e.searchInput : '',
        // },
      })
        .then((res) => {
          this.paginations.last_page = res.data.meta.last_page;
          this.paginations.items_per_page = res.data.meta.per_page;

          this.branches = res.data.data;

          this.loaderPage = false;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
          this.loaderPage = false;
        });
    },
    fetchData(e) {
      this.$router.replace({ query: { page: e } });
      this.setRows();
    },
  },
  created() {
    this.canEdit = this.$permission.allowed("branches/edit/");
    this.canDelete = this.$permission.allowed("branches/delete");
    this.canAdd = this.$permission.allowed("branches/add");
    if (this.$route.query.page) {
      this.paginations.current_page = +this.$route.query.page;
    }
    this.setRows();
  },

  // ======= hooks
};
</script>

<style lang="scss" scoped></style>
